import { render } from "./NcrmWorkflowFileImportHistory.vue?vue&type=template&id=b02c56b2&scoped=true"
import script from "./NcrmWorkflowFileImportHistory.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowFileImportHistory.vue?vue&type=script&lang=js"

import "./NcrmWorkflowFileImportHistory.vue?vue&type=style&index=0&id=b02c56b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b02c56b2"]])

export default __exports__